import { Paper, Button } from "@mui/material";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import { serverGet } from "lib/serverRequest";
import { serverPost } from "lib/serverRequest";
import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CapacityForm from "./CapacityForm";

export default function CapacityComponent() {
  const history = useHistory();
  const formRef = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState({});

  const errorAction = (res, err) => {
    if (!res && err?.message) {
      enqueueSnackbar(err?.message, { variant: "warning" });
    } else {
      enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
    }
  };

  const loadData = () => {
    serverGet({
      url: "box/capacity/get",
      onFinish: (res, err) => {
        if (res === false) {
          errorAction(res, err);
          return;
        }
        setData(res);
      },
    });
  };

  const handleClickAdd = () => {
    const formData = formRef.current.prepare();
    if (formData) {
      serverPost({
        url: "box/capacity/create",
        data: data,
        onFinish: (res, err) => {
          if (res === false) {
            errorAction(res, err);
            return;
          }
          enqueueSnackbar(
            `Successfully ${data?.id ? "Updated" : "Added"} in.`,
            { variant: "success" }
          );
        },
      });
    }
  };

  useEffect(() => {
    loadData();
    //eslint-disable-next-line
  }, []);

  return (
    <div>
      <Paper>
        <div
          className="p-4 flex justify-between items-center border-b border-white-gray"
          // onClick={handleClickAdd}
        >
          <CustomText variant="h6" bold={600}>
            Capacity Control
          </CustomText>
        </div>
        <div className="p-4 w-full">
          <CapacityForm ref={formRef} data={data} onChange={setData} />
        </div>
      </Paper>
      <div className="flex items-center my-4">
        <Button variant="contained" color="secondary" onClick={handleClickAdd}>
          {Boolean(data?.id) ? "Update" : "Create"}
        </Button>
        <Button
          className="mx-2"
          variant="outlined"
          color="secondary"
          onClick={() => history.goBack()}
        >
          CANCEL
        </Button>
      </div>
    </div>
  );
}
